import React, { Dispatch } from 'react';

import { Colors } from 'ui/constants/colors';
import { StringIndexed } from 'types/table';
import { InfoTableRow } from './info-table-row';
import { IInfoTableColumn } from 'types/info-table';
import { PreloaderStyled } from 'ui/atoms/preloader.styled';

import styles from './styles.module.css';

interface IInfoTableRowsProps<T> {
  data: StringIndexed<T>[] | null;
  columns: IInfoTableColumn<T>[];
  isLoading?: boolean;
  selectedIds?: number[];
  onRowClick?: Dispatch<StringIndexed<T>>;
}

export const InfoTableRows = <T,>(props: IInfoTableRowsProps<T>) => {
  const { isLoading, data, columns, selectedIds, onRowClick } = props;

  if (isLoading) {
    return (
      <div className={styles.rows}>
        <div className={styles.preloaderWrapper}>
          <PreloaderStyled />
        </div>
      </div>
    );
  }

  if (!isLoading && !!data && data.length < 1) {
    return (
      <div className={styles.rows}>
        <div className={styles.noContent}>No data</div>
      </div>
    );
  }

  if (data) {
    return (
      <div className={styles.rows}>
        {data.map((row, index) => (
          <InfoTableRow
            key={index}
            isSelected={selectedIds ? selectedIds?.includes(row.id as number) : false}
            row={{ ...row, index }}
            columns={columns}
            onRowClick={onRowClick}
          />
        ))}
      </div>
    );
  }

  return null;
};
